import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHeatPump = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconHeatPump",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M450-282v-126l-89 89q20 14 43 23t46 14m60-1q24-4 47-13t42-23l-89-89zm131-78q14-20 23-42t13-47H552zm-89-149h125q-5-23-13-45t-23-43zm-42-42 89-89q-20-14-42-23t-47-14zm-30 112q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11m-30-112v-125q-24 4-46 13t-43 23zm-167 42h125l-89-88q-14 20-23 42t-13 46m36 149 89-89H282q5 24 14 47t23 42M200-120q-33 0-56-23t-24-57v-560q0-33 24-56t56-24h560q33 0 57 24t23 56v560q0 33-23 57t-57 23z"
  })
}));